import {
  PaymentSummaryType,
  SavedCardConfirmedSummaryType,
} from "@models/components/paymentMethod.model";
import { CaseReducer, createSlice, PayloadAction } from "@reduxjs/toolkit";

export type { PaymentSummaryType, SavedCardConfirmedSummaryType };

type initialType = {
  authModal: boolean;
  loginModal: boolean;
  memberListing: boolean;
  passwordModal: boolean;
  paymentIframeModal: boolean;
  paymentIframeUrl: string;
  paymentSummary?: PaymentSummaryType;
  registerModal: boolean;
  savedCardConfirmedModal: boolean;
  savedCardConfirmedSummary?: SavedCardConfirmedSummaryType;
};

type modalSliceReducer<Payload> = CaseReducer<
  initialType,
  PayloadAction<Payload>
>;

const updateAuthModal: modalSliceReducer<boolean> = (state, action) => {
  state.authModal = action.payload;
};
const updateLoginModal: modalSliceReducer<boolean> = (state, action) => {
  state.loginModal = action.payload;
};
const updateMemberListing: modalSliceReducer<boolean> = (state, action) => {
  state.memberListing = action.payload;
};
const updateRegisterModal: modalSliceReducer<boolean> = (state, action) => {
  state.registerModal = action.payload;
};
const updatePasswordModal: modalSliceReducer<boolean> = (state, action) => {
  state.passwordModal = action.payload;
};
const updatePaymentIframeModal: modalSliceReducer<boolean> = (
  state,
  action
) => {
  state.paymentIframeModal = action.payload;
};
const updatePaymentIframeUrl: modalSliceReducer<string> = (state, action) => {
  state.paymentIframeUrl = action.payload;
};
const updatePaymentSummary: modalSliceReducer<
  PaymentSummaryType | undefined
> = (state, action) => {
  state.paymentSummary = action.payload;
};
const updateSavedCardConfirmedModal: modalSliceReducer<boolean> = (
  state,
  action
) => {
  state.savedCardConfirmedModal = action.payload;
};
const updateSavedCardConfirmedSummary: modalSliceReducer<
  SavedCardConfirmedSummaryType | undefined
> = (state, action) => {
  state.savedCardConfirmedSummary = action.payload;
};

const initialState: initialType = {
  authModal: false,
  loginModal: false,
  memberListing: false,
  passwordModal: false,
  paymentIframeModal: false,
  paymentIframeUrl: "",
  paymentSummary: undefined,
  registerModal: false,
  savedCardConfirmedModal: false,
  savedCardConfirmedSummary: undefined,
};

const modalSlice = createSlice({
  initialState,
  name: "modal",
  reducers: {
    updateAuthModal,
    updateLoginModal,
    updateMemberListing,
    updatePasswordModal,
    updatePaymentIframeModal,
    updatePaymentIframeUrl,
    updatePaymentSummary,
    updateRegisterModal,
    updateSavedCardConfirmedModal,
    updateSavedCardConfirmedSummary,
  },
});

export default modalSlice;
